import { useState } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar, Footer, DemoModal } from "@/components/Layout";
import ChatBot from "@/components/ChatBot";
import Home from "@/pages/Home";
import Product from "@/pages/Product";
import Technology from "@/pages/Technology";
import About from "@/pages/About";
import Builders from "@/pages/Builders";
import Investor from "@/pages/Investor";
import Contact from "@/pages/Contact";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import { Wind } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--soft-white)' }}>
        <Wind className="w-8 h-8 animate-spin" style={{ color: 'var(--aqua)' }} />
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  if (typeof window !== 'undefined') {
    window.scrollTo(0, 0);
  }
  return null;
}

function AppContent() {
  const [showDemo, setShowDemo] = useState(false);
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';
  const isAuth = location.pathname === '/auth';

  return (
    <>
      {!isDashboard && !isAuth && <Navbar onBookDemo={() => setShowDemo(true)} />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home onBookDemo={() => setShowDemo(true)} />} />
        <Route path="/product" element={<Product onBookDemo={() => setShowDemo(true)} />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/about" element={<About />} />
        <Route path="/builders" element={<Builders onBookDemo={() => setShowDemo(true)} />} />
        <Route path="/investor" element={<Investor />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      </Routes>
      {!isDashboard && !isAuth && <Footer />}
      <DemoModal isOpen={showDemo} onClose={() => setShowDemo(false)} />
      <ChatBot />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
